<template>
  <div>
    <el-card>
      <div class="portrait">
        <span>头像：</span>
        <div
          class="portrait_box"
          @mouseenter="isSend()"
          @mouseleave="isLeave()"
        >
          <div class="mack">
            <img :src="headImg" alt="" />
            <div class="mack_box" v-show="flang" @click="show = true">
              <p>修改</p>
            </div>
          </div>
        </div>
        <!-- 选取头像隐藏弹窗 -->
        <div class="replace_head" v-show="show">
          <div class="occlude">
            <h3>修改头像</h3>
            <i class="iconfont icon-quxiao-copy" @click="show = false"></i>
          </div>
          <p>我们为您精心挑选了9种不同风格的头像，快选一个您喜欢的吧。</p>
          <div class="port_img">
            <div
              v-for="(item, index) in portraitArr"
              :key="index"
              :class="current === index ? 'active' : ''"
            >
              <img :src="item.imgUrl" alt="" @click="switchTag(index)" />
            </div>
          </div>
          <div class="head_btn">
            <el-button @click="show = false">确定</el-button>
          </div>
        </div>
      </div>
      <div class="info_box">
        <p class="info_line"><span>用户名：</span>{{ addData.UserName }}</p>
        <p class="info_line" v-if="addData.Telephone === null">
          <span>联系电话：</span>未绑定手机号
        </p>
        <p class="info_line" v-else>
          <span>联系电话：</span>{{ addData.Telephone }}
        </p>
        <p class="info_line">
          <span>归属医院：</span>{{ addData.HospitalName }}
        </p>
        <p class="info_line"><span>归属码：</span>{{ addData.HospitalCode }}</p>
      </div>
      <div class="user_input">
        <span>姓名：</span>
        <el-input
          v-model.trim="uesrForm.name"
          placeholder="请输入姓名"
        ></el-input>
      </div>
      <div class="user_input">
        <span>邮箱：</span>
        <el-input
          v-model.trim="uesrForm.email"
          placeholder="请输入邮箱"
        ></el-input>
      </div>
      <div class="user_input">
        <span>QQ: </span>
        <el-input
          v-model.trim="uesrForm.tencent"
          placeholder="请输入QQ号"
        ></el-input>
      </div>
      <!-- 按钮 -->
      <div class="operation">
        <el-button class="succ_btn" @click="toHome()">取消</el-button>
        <el-button type="success" class="submit_btn" @click="ModifyData()"
          >保存</el-button
        >
      </div>
    </el-card>
  </div>
</template>

<script>
import { getUserInfo, updateUserInfo } from "@/api/examination.js";
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      uesrForm: {
        name: "",
        email: "",
        tencent: "",
      },
      addData: {},
      portraitArr: [
        {
          photoID: 1,
          imgUrl: require("@/assets/portrait/1.png"),
        },
        {
          photoID: 2,
          imgUrl: require("@/assets/portrait/2.png"),
        },
        {
          photoID: 3,
          imgUrl: require("@/assets/portrait/3.png"),
        },
        {
          photoID: 4,
          imgUrl: require("@/assets/portrait/4.png"),
        },
        {
          photoID: 5,
          imgUrl: require("@/assets/portrait/5.png"),
        },
        {
          photoID: 6,
          imgUrl: require("@/assets/portrait/6.png"),
        },
        {
          photoID: 7,
          imgUrl: require("@/assets/portrait/7.png"),
        },
        {
          photoID: 8,
          imgUrl: require("@/assets/portrait/8.png"),
        },
        {
          photoID: 9,
          imgUrl: require("@/assets/portrait/9.png"),
        },
      ],
      current: 0,
      photoID: "",
      flang: false, //头像的遮罩层
      show: false, // 换头像弹出层
      headImg: require("@/assets/portrait/1.png"),
    };
  },
  methods: {
    isSend() {
      this.flang = true;
      // console.log("显示了");
    },
    isLeave() {
      this.flang = false;
      // console.log("隐藏了");
    },
    switchTag(index) {
      this.current = index;
      this.photoID = this.current + 1;
      // console.log(this.photoID, "选取");
      if (this.photoID === this.current + 1) {
        this.headImg = require(`@/assets/portrait/${this.photoID}.png`);
      }
    },
    getUserData() {
      let parmas = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
      };
      return getUserInfo(parmas);
    },
    // 取消返回首页
    toHome() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:Basis:cancel",
          parent_code: "PersonalCenter:Basis",
        },
        "statetime"
      );
      this.$router.push("/papers");
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    // 修改基本信息
    async ModifyData() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:Basis:save",
          parent_code: "PersonalCenter:Basis",
        },
        "statetime"
      );
      let parmas = {
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        realName: this.uesrForm.name,
        email: this.uesrForm.email,
        qq: this.uesrForm.tencent,
        photoID: this.photoID,
      };
      const Data = await updateUserInfo(parmas);
      if (Data.status === 200) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        this.$bus.$emit("go", this.headImg); //这里是传头像
        this.getUserData();
      } else {
        this.$message.error("保存失败");
      }
      // console.log(Data, "修改接口");
    },
  },
  async created() {
    this.stateArr = [];
    let result = await this.getUserData();
    this.addData = result.data.Data[0];
    this.uesrForm.name = this.addData.RealName;
    this.uesrForm.email = this.addData.Email;
    this.uesrForm.tencent = this.addData.qq;
    this.switchTag(this.addData.photoID - 1);
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}
.el-card {
  border: none;
}
::v-deep .el-card__body {
  padding: 44px 24px;
}
.portrait {
  display: flex;
  align-items: center;
  position: relative;
  span {
    display: inline-block;
    width: 75px;
    font-size: 15px;
  }
  .portrait_box {
    width: 189px;
    height: 189px;
    //    border: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    .mack {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      display: block;
      position: relative;
      img {
        display: block;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        cursor: pointer;
      }
      .mack_box {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100px;
        height: 100px;
        // opacity: 0; //隐藏
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        // pointer-events:none;
        // display: none;
        p {
          color: #ffffff;
          font-size: 18px;
          letter-spacing: 4px;
        }
      }
    }
  }
}
.info_box {
  p:nth-last-child(1) {
    margin-bottom: 40px;
  }
  .info_line {
    display: flex;
    margin-bottom: 49px;
    span {
      display: inline-block;
      width: 75px;
      font-size: 15px;
      margin-right: 50px;
    }
  }
}
.user_input {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  span {
    margin-right: 80px;
    width: 48px;
  }
  .el-input {
    width: 609px;
    height: 40px;
  }
}
.operation {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin: 100px 0 70px 0;
  padding-bottom: 100px;
  background-color: #ffffff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
.replace_head {
  position: absolute;
  left: 90px;
  top: 40px;
  width: 440px;
  height: 570px;
  border-radius: 10px;
  padding: 14px;
  background: #f0f0f0;
  z-index: 99999;
  .occlude {
    position: relative;
    i {
      font-size: 48px !important;
      position: absolute;
      right: -14px;
      top: -18px;
    }
  }
  p {
    margin: 20px 0px 20px 0px;
    font-size: 14px;
  }
  .port_img {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    > div {
      width: 100px;
      height: 100px;
      margin: 15px 18px;
      img {
        width: 96px;
        height: 96px;
        display: inline-block;
        margin: 2px 2px;
      }
    }
  }
  .head_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      margin-top: 12px;
      width: 88px;
      background: #00a7dd;
      border: 1px solid #00a7dd !important;
      color: #ffffff;
    }
  }
}
.active {
  // border: 1px solid rgb(60, 184, 241);
  background: rgb(60, 184, 241);
  border-radius: 50%;
}
</style>